import { clsx } from 'clsx';
import { Button } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import { FunctionFieldProps, FunctionField, Link } from 'react-admin';

import { querySerialize } from '@utils';
import { CreditStatus, Dealer, DealerType } from '@types';
import cls from './CountCreditsBtn.module.css';


interface Props {
  statuses: CreditStatus[],
  className?: string,
  label?: string,
  counterField: string;
}

const CreditsWidget = ({
  label, statuses, className, dealer, counterField,
}: Props & { dealer: Dealer }) => {
  const linkToUsers = '/credit?' + querySerialize({
    filter: JSON.stringify({
      status: statuses,
      mainBuyerName: dealer.type === DealerType.BUYER ? dealer.name : undefined,
      retailers: dealer.type === DealerType.RETAILER ? dealer.id : undefined,
      associates: dealer.type === DealerType.ASSOCIATE ? dealer.id : undefined,
    }),
    displayedFilters: JSON.stringify({
      mainBuyerName: dealer.type === DealerType.BUYER ? true : undefined,
      retailers: dealer.type === DealerType.RETAILER ? true : undefined,
      associates: dealer.type === DealerType.ASSOCIATE ? true : undefined,
    }),
  });

  return (
    <div
      onClick={e => e.stopPropagation()}
      className={clsx(cls.box, className)}>
      <div className={cls.counter}>{dealer[counterField] ?? 0}</div>
      <Link to={linkToUsers}>
        <Button
          icon={<LoginOutlined className={cls.icon} />}
          type="ghost"
          className={cls.btn}
          title={label}
        />
      </Link>
    </div>
  );
};

export const CountCreditsBtn = (props: Partial<FunctionFieldProps> & Props) => {
  return (
    <FunctionField
      {...props}
      sortable={false}
      render={(record: Dealer) => (
        <CreditsWidget
          dealer={record}
          statuses={props.statuses}
          className={props.className}
          label={props.label}
          counterField={props.counterField}
        />
      )}
    />
  );
};
